import React, { useState, useEffect } from "react";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { ToastContainer } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  changeSingleClientModal,
  requestUpdateSingleClientSale,
  resetSingleClientActiveSale,
} from "../../../../../redux/actions/single-client";
import { Input } from "../../../../library/input";
import { Select } from "../../../../library/select";
import { Textarea } from "../../../../library/textarea";
import { Popup } from "../../../../library/popup";
import { SolidButton, TransparentButton } from "../../../../library/button";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = (props) => {
  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.singleClient.showModals.editSaleModal
  );
  const user = useSelector(
    (state) => state && state.auth && state.auth.user && state.auth.user.id
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const loading = useSelector((state) => state.singleClient.updateSale.loading);
  const activeSale = useSelector((state) => state.singleClient.activeSale);

  const [saleInformation, setSaleInformation] = useState({});

  const statuses = [
    {
      id: 0,
      value: "",
      title: "Velg",
      selected: true,
      disabled: true,
    },
    {
      id: 1,
      value: "Ikke betalt",
      title: "Ikke betalt",
      selected: false,
      disabled: false,
    },
    {
      id: 2,
      value: "Betalt",
      title: "Betalt",
      selected: false,
      disabled: false,
    },
    {
      id: 3,
      value: "Kreditert",
      title: "Kreditert",
      selected: false,
      disabled: false,
    },
    {
      id: 4,
      value: "Sendt til inkasso",
      title: "Sendt til inkasso",
      selected: false,
      disabled: false,
    },
  ];

  const vats = [
    {
      id: 0,
      value: "",
      title: "Velg",
      selected: true,
      disabled: true,
    },
    {
      id: 1,
      value: 1.06,
      title: "6%",
      selected: false,
      disabled: false,
    },
    {
      id: 2,
      value: 1.25,
      title: "25%",
      selected: false,
      disabled: false,
    },
    {
      id: 3,
      value: 0,
      title: "Ingen",
      selected: false,
      disabled: false,
    },
  ];

  const clickUpdateSale = () => {
    if (
      saleInformation.title &&
      saleInformation.timestamp &&
      saleInformation.status &&
      saleInformation.price &&
      saleInformation.vat
    ) {
      const productDate = new Date(saleInformation.timestamp);
      var productDateTimestamp = moment(productDate).unix();
      const salesObject = {
        id: props.match.params.id,
        title: saleInformation.title,
        description: saleInformation.description,
        timestamp: productDateTimestamp,
        status: saleInformation.status,
        price: parseInt(saleInformation.price.toString().replace(/ /g, "")),
        vat: saleInformation.vat,
        key: saleInformation.key,
      };
      dispatch(
        requestUpdateSingleClientSale({
          companyId: selectedCompany,
          user: user,
          sale: salesObject,
        })
      );
    } else {
      sendErrorNotification("Vennligst fyll inn alle felt.");
    }
  };

  const handleClose = () => {
    dispatch(changeSingleClientModal({ editSaleModal: false }));
    dispatch(resetSingleClientActiveSale());
  };

  useEffect(() => {
    if (Object.keys(saleInformation).length === 0) {
      setSaleInformation({
        key: activeSale.key,
        id: activeSale.id,
        timestamp: moment.unix(activeSale.timestamp).format("yyyy-MM-DD"),
        title: activeSale.title,
        price: activeSale.price,
        status: activeSale.status,
        description: activeSale.description,
        vat: activeSale.vat,
      });
    }
  }, [activeSale]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre salg"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Oppdaterer.." : "Oppdater"}
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-sync"></i>
            )
          }
          onClick={() => clickUpdateSale()}
          type="button"
        />,
      ]}
    >
      <div className="edit-sale-content-container">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Produktnavn
            </Label>
            <Input
              value={saleInformation.title}
              onChange={(e) =>
                setSaleInformation({
                  ...saleInformation,
                  title: e.target.value,
                })
              }
              placeholder="Produktnavn"
              type="text"
            />
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Beskrivelse
            </Label>
            <Textarea
              value={saleInformation.description}
              onChange={(e) =>
                setSaleInformation({
                  ...saleInformation,
                  description: e.target.value,
                })
              }
              placeholder="Produktbeskrivelse"
              rows="3"
            />
          </Col>
        </Row>
        <hr />
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Dato
            </Label>
            <Input
              value={saleInformation.timestamp}
              onChange={(e) =>
                setSaleInformation({
                  ...saleInformation,
                  timestamp: e.target.value,
                })
              }
              type="date"
              id="date"
              name="date"
            />
          </Col>
          <Col className="info-col">
            <Label version={1} weight="bold">
              Status
            </Label>
            <Select
              value={saleInformation.status}
              onChange={(e) =>
                setSaleInformation({
                  ...saleInformation,
                  status: e.target.value,
                })
              }
              items={statuses}
            />
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Pris i netto (NOK)
            </Label>
            <Input
              format="amount"
              value={saleInformation.price}
              onChange={(e) =>
                setSaleInformation({
                  ...saleInformation,
                  price: e.target.value,
                })
              }
              type="text"
              id="price"
              name="price"
              placeholder="0"
            />
          </Col>
          <Col className="info-col">
            <Label version={1} weight="bold">
              Mva
            </Label>
            <Select
              onChange={(e) =>
                setSaleInformation({ ...saleInformation, vat: e.target.value })
              }
              value={saleInformation.vat}
              items={vats}
            />
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default withRouter(Index);
